import styled, { css, keyframes } from 'styled-components';
import { Container as AsyncSelect } from 'components/AsyncSelect/styles';
import { Container as Select } from 'components/Select/styles';
import { Form as Unform } from '@unform/web';

import { fadeIn, fadeOut } from 'styles/animation';
import { device } from 'styles/device';

interface IContainerProps {
  $mini?: boolean;
}

export const expandSelect = keyframes`
from {
   width: 250px;
}

 to {
  width: 40vw;
 }
`;

export const Container = styled.div<IContainerProps>`
  -webkit-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  width: 100%;
  height: 66px;
  padding: 0.625rem calc(0.9375rem + 15px) 0.625rem calc(0.9375rem + 15px);
  color: ${props => props.theme.fontColor};
  /* position: absolute; */
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  background-color: ${props => props.theme.background};

  @media ${device.laptopM} {
    padding: 0.625rem 15px 0.625rem 15px;
  }

  nav {
    display: flex;
    align-items: center;
    min-width: 180px;
    width: ${props => (props.$mini ? '287px' : '437px')};

    button {
      background: transparent;
      border: none;
      padding: 0;
      margin: 0 5px 0 10px;
      display: flex;
      align-items: center;
      svg {
        color: ${props => props.theme.fontColor};
        font-size: 28px;
      }
    }

    @media ${device.laptopM} {
      width: 287px;
      button {
        margin: 0 5px 0 0;
      }
    }

    span {
      font-size: 1rem;
      font-weight: 500;
      margin-left: 17px;
      text-transform: uppercase;
    }
  }

  aside {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 200px;
  }
`;

// Utilizado o cifrão para tornar a prop transiente
// Ref: https://styled-components.com/docs/api#transient-props
interface IFromProps {
  $searchopen: boolean;
}
export const Form = styled(Unform)<IFromProps>`
  ${props =>
    props.$searchopen &&
    css`
      ${AsyncSelect} {
        animation: ${expandSelect} 0.5s ease-in 0s 1 normal forwards;
      }
      ${Select} {
        animation: ${expandSelect} 0.5s ease-out 0s 1 reverse;
      }
    `}
`;

export const Profile = styled.div`
  margin-left: 20px;
  padding-left: 20px;
  align-items: center;
  cursor: pointer;
  display: flex;

  > div {
    text-align: right;
    margin-right: 10px;

    strong {
      display: block;
      color: #333;
    }

    a {
      display: block;
      margin-top: 2px;
      font-size: 12px;
      color: #999;
    }
  }

  b {
    margin-left: 5px;
    width: 0;
    height: 0;
    vertical-align: middle;
    border-top: 4px dashed;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;

    -webkit-transition: all 0.15s ease 0s;
    transition: all 0.15s ease 0s;
    user-select: none;

    cursor: pointer;

    &:hover {
      border-top: 4px dashed ${props => props.theme.button.primary.out};
    }
  }
`;

interface IMenuListProps {
  $visible?: boolean;
}
export const MenuList = styled.ul<IMenuListProps>`
  position: absolute;
  top: 100%;
  left: auto;
  right: 35px;
  z-index: 1000;

  top: 4rem;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;

  text-align: left;
  /* list-style: none; */
  border-radius: 4px;
  background-color: #fff;
  background-clip: padding - box;
  border: 0 solid rgba(34, 42, 66, 0.15);
  box-shadow: 0 1px 2px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  user-select: none;

  ${props =>
    props.$visible
      ? css`
          animation: ${fadeIn} 0.1s ease-in;
          display: block;
        `
      : css`
          animation: ${fadeOut} 0.1s ease-out;
          display: none;
        `} *
   &::before {
    display: inline - block;
    position: absolute;
    width: 0;
    height: 0;
    content: '';
    top: -5px;
    left: auto;
    right: 10px;
    color: #fff;
    border-bottom: 0.4em solid;
    border-right: 0.4em solid transparent;
    border-left: 0.4em solid transparent;
  }
`;

export const Item = styled.li`
  padding: 0.25rem 0.5rem;
  list-style: none;

  button {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.menu.fontColor};
    font-size: 0.75rem;
    padding: 0.6rem 0.25rem 0.6rem 0.5rem;

    -webkit-transition: all 0.15s linear;
    transition: all 0.15s linear;
    span {
      color: ${props => props.theme.menu.fontColor};
    }
    &:hover {
      background-color: hsla(0, 0%, 87.1%, 0.3);
    }

    svg {
      margin-right: 1rem;
    }
  }
`;
